/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import debounce from "lodash.debounce";
import { useRef } from "react";
import { cn } from "tailwind-variants";
import { calculateSizes } from "./utils";
import { useDtfStore } from "../store";
import "./Quantity.scss";
import { renderList } from "common/vue/render-list";

export default function JerseyNumbersQuantity({ ...restProps }) {
  const MAX_QUANTITY = 999;
  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  // useRef keeps a single debounce instance across renders to avoid timer accumulation.
  const updatePricingRef = useRef(
    debounce(() => {
      // @ts-expect-error TS(2339): Property 'quantity' does not exist on type 'unknow... Remove this comment to see the full error message
      const { quantity } = letterNumberArtwork();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (quantity) store.getArtworksPricing();
    }, 500)
  );

  function handleChange(field: any, event: any) {
    const { value } = event.target;
    let quantity = value.replace(/[^0-9]/g, "").replace(/^0/, "");
    if (Number(quantity) > 0) {
      quantity = Math.min(Number(quantity), MAX_QUANTITY);
    }
    event.target.value = quantity;
    const quantities = Object.entries({
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...letterNumberArtwork().quantities,
      [field]: quantity
    }).reduce((acc, [number, qty]) => {
      if (qty) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        acc[number] = qty;
      }
      return acc;
    }, {});
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const totalQuantity = Object.values(quantities).reduce((acc, curr) => acc + Number(curr), 0);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const style = letterNumberArtwork().style || "none";
    const sizes = calculateSizes({
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...letterNumberArtwork(),
      quantities,
      style
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const width = Object.values(sizes)
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      .reduce((sum, current) => sum + current.width, 0)
      .toFixed(2);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      quantities,
      quantity: totalQuantity,
      sizes,
      width
    });
    updatePricingRef.current();
  }

  function handleBlur() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updatePdpDates();
  }

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("jersey-numbers-quantity", restProps.className)}>
      {renderList(10, n => (
        <div className="jersey-numbers-quantity__field" key={n}>
          <label
            className="jersey-numbers-quantity__label"
            htmlFor={`input-${n}`}
            data-testid="jersey-numbers-quantity-label"
          >
            #{n - 1}
          </label>
          <input
            className="jersey-numbers-quantity__input"
            id={`input-${n}`}
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            value={letterNumberArtwork().quantities[n - 1]}
            maxLength={3}
            type="tel"
            onInput={e => {
              handleChange(n - 1, e);
            }}
            onBlur={handleBlur}
            data-testid="jersey-numbers-quantity-input"
          />
        </div>
      ))}
    </div>
  );
}
